import * as React from "react";
import { createContext, useState, SetStateAction, Dispatch } from "react";

export interface FormattedResource {
  title: string;
  id: string;
  thumbnail?: string;
}

export interface FormattedData {
  formatted: FormattedResource[];
  numFilteredOut: number;
  resourceCount: number | null;
}

export interface PublishContextValue {
  query: string;
  pageNum: number;
  selectedResource: FormattedResource | null;
  formattedData: FormattedData;
}

export type PublishDispatchContextValue = Dispatch<
  SetStateAction<PublishContextValue>
>;

export const PublishContext = createContext<PublishContextValue | null>(null);

export const PublishDispatchContext =
  createContext<PublishDispatchContextValue | null>(null);

export interface PubilshProviderProps {
  children: React.ReactNode;
}
export const PublishProvider: React.FC<PubilshProviderProps> = ({
  children,
}: PubilshProviderProps) => {
  const [publishState, setPublishState] = useState<PublishContextValue>({
    query: "",
    pageNum: 0,
    selectedResource: null,
    formattedData: { formatted: [], numFilteredOut: 0, resourceCount: null },
  });

  return (
    <PublishContext.Provider value={publishState}>
      <PublishDispatchContext.Provider value={setPublishState}>
        {children}
      </PublishDispatchContext.Provider>
    </PublishContext.Provider>
  );
};
